import GenerationFixedButton from './GenerationFixedButton'

export default GenerationFixedButton
